import { LoadingSpinner } from '@components/Generic'
import axios from 'axios'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'

import { EnterPin } from '@components/GoToMobile/steps/EnterPin'
import { Error } from '@components/GoToMobile/steps/Error'
import { Intro } from '@components/GoToMobile/steps/Intro'
import { devLog } from '@methods/devLog'
import { GetSwitchToMobileContextResponse } from './SwitchToMobilePage'
import { API_URL, GOTOMOBILE_SERVICE_PATH } from '@constants/apiUrl'
import { cx } from '@/utils/cx'

export const ContinueOnMobilePage = observer(() => {
  const store = useContext(StoreContext)
  const [step, setStep] = useState(0)

  const [context, setContext] = useState<GetSwitchToMobileContextResponse | undefined>()

  const { startMobileSessionUrl, closeMobileSessionUrl, verifyPinCodeUrl } =
    context?.endpoints || {}

  const nextStep = () => {
    setStep(step + 1)
  }

  const initComponent = async () => {
    try {
      const { data } = await axios.get<GetSwitchToMobileContextResponse>(
        `${API_URL}/${GOTOMOBILE_SERVICE_PATH}/get-context`,
        {
          withCredentials: true,
        }
      )

      devLog(data)
      setContext(data)

      nextStep()
    } catch (error) {
      devLog(error)
    }
  }

  useEffect(() => {
    void initComponent()
  }, [])

  const renderCurrentStep = () => {
    if (!context) return <LoadingSpinner />

    switch (step) {
      case 0:
        return (
          <>
            <LoadingSpinner />
          </>
        )
      case 1:
        return <Intro nextStep={nextStep} startMobileSessionUrl={startMobileSessionUrl} />
      case 2:
        return (
          <EnterPin
            nextStep={nextStep}
            maxAttempts={context?.pinCode?.maxAttempts}
            verifyPinCodeUrl={verifyPinCodeUrl}
            closeMobileSessionUrl={closeMobileSessionUrl}
          />
        )
      case 3:
        return <Error />

      default:
        return <></>
    }
  }

  return (
    <div className={cx('page-container mobile-m-0', step === 1 && 'vertically-centered')}>
      {renderCurrentStep()}
    </div>
  )
})
